import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageHero from "../components/PageHero";
import { legalPolicies } from "../data/siteContent";
import { apiRequest } from "../lib/api";

export function LegalPage() {
  const { policy } = useParams();
  const fallback = legalPolicies[policy] || legalPolicies.privacy;
  const [remote, setRemote] = useState(null);
  useEffect(() => { let active = true; const policyType = policy === 'terms' ? 'TERMS_OF_USE' : 'PRIVACY_POLICY'; apiRequest(`/public/policies/${policyType}`).then((response) => { if (active) setRemote(response.data); }).catch(() => {}); return () => { active = false; }; }, [policy]);
  const content = remote ? { eyebrow: 'Legal', title: remote.title, intro: '', updated: `Version ${remote.version}`, body: remote.content } : fallback;
  return (
    <>
      <PageHero
        eyebrow={content.eyebrow}
        title={content.title}
        copy={content.intro}
      />
      <section id="content" className="section-space bg-white">
        <div className="container max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[.16em] text-slate">
            {content.updated}
          </p>
          {content.body ? <div className="prose prose-slate mt-10 max-w-none" dangerouslySetInnerHTML={{ __html: content.body }} /> : <div className="mt-10 space-y-10">
            {content.sections.map(([title, copy]) => (
              <section key={title}>
                <h2 className="font-display text-2xl font-bold text-ink">
                  {title}
                </h2>
                <p className="mt-3 text-sm leading-8 text-slate">{copy}</p>
              </section>
            ))}
          </div>}
          <div className="mt-12 rounded-3xl bg-mist p-6 text-sm leading-7 text-slate">
            <strong className="text-ink">Important:</strong> This is starter
            content for the product build and is not legal advice. The final
            version should be reviewed and approved before public launch.
          </div>
        </div>
      </section>
    </>
  );
}
